import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type UpsertCourtCasePaymentEventMutationVariables = Types.Exact<{
  input: Types.CourtCasePaymentEventInput
}>

export type UpsertCourtCasePaymentEventMutation = {
  __typename?: 'Mutation'
  upsertCourtCasePaymentEvent: {
    __typename?: 'CourtCasePaymentEvent'
    courtCaseUuid?: string | null
  }
}

export const UpsertCourtCasePaymentEventDocument = gql`
  mutation UpsertCourtCasePaymentEvent($input: CourtCasePaymentEventInput!) {
    upsertCourtCasePaymentEvent(input: $input) {
      courtCaseUuid
    }
  }
`
export type UpsertCourtCasePaymentEventMutationFn = ApolloReactCommon.MutationFunction<
  UpsertCourtCasePaymentEventMutation,
  UpsertCourtCasePaymentEventMutationVariables
>
export function useUpsertCourtCasePaymentEventMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpsertCourtCasePaymentEventMutation,
    UpsertCourtCasePaymentEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpsertCourtCasePaymentEventMutation,
    UpsertCourtCasePaymentEventMutationVariables
  >(UpsertCourtCasePaymentEventDocument, options)
}
export type UpsertCourtCasePaymentEventMutationHookResult = ReturnType<
  typeof useUpsertCourtCasePaymentEventMutation
>
export type UpsertCourtCasePaymentEventMutationResult =
  ApolloReactCommon.MutationResult<UpsertCourtCasePaymentEventMutation>
export type UpsertCourtCasePaymentEventMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpsertCourtCasePaymentEventMutation,
  UpsertCourtCasePaymentEventMutationVariables
>
